import React, { useEffect, useState, useContext } from 'react'
import { format } from 'date-fns'
import ReactTooltip from 'react-tooltip'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router-dom'

import { api, authHeaders } from '../../../../services/api'

import scrollUtils from '../../../../util/scroll'
import arrayUtils from '../../../../util/array'
import { stringToDate, getDateString, getDate } from '../../../../util/date'

import useQuery from '../../../../hooks/useQuery'

import BoxDadosBasicos from '../../../../boxes/EspacoMedico/DadosBasicos'
import BoxDadosPessoais from '../../../../boxes/EspacoMedico/DadosPessoais'
import BoxEndereco from '../../../../boxes/EspacoMedico/Endereco'
import BoxFormacoes from '../../../../boxes/EspacoMedico/Formacoes'
import BoxExperienciasProfissionais from '../../../../boxes/EspacoMedico/ExperienciaProfissional'
import BoxContatos from '../../../../boxes/EspacoMedico/Contatos'
import BoxArquivos from '../../../../boxes/Arquivos'

import Modal from '../../../../components/Modal'
import GerenciamentoDocumentos from '../../../../components/GerenciamentoDocumentos'

import { loadTips } from '../../../../util/tip'
import { TipContext } from '../../../../contexts/TipContext'

import {
    Container,
    BoxDocumentos
} from './styles'

import { GlobalContext } from '../../../../contexts/GlobalContext'
import { FiAlertTriangle, FiPlusCircle } from 'react-icons/fi'

export function concatFormacoes(formacao, separator = ' ') {
    if (formacao.formacao_pai) {
        return `${concatFormacoes(formacao.formacao_pai)}${separator}${formacao.descricao}`
    }

    return `${formacao.descricao}`
}

export function concatFormacoesArray(formacao) {
    if (formacao.formacao_pai) {
        return [
            ...concatFormacoesArray(formacao.formacao_pai),
            {
                label: formacao.descricao,
                value: formacao.id
            }
        ]
    }

    return [
        {
            label: formacao.descricao,
            value: formacao.id
        }
    ]
}

export default function () {
    const { setCodigo } = useContext(TipContext)
    const { user, checkException } = useContext(GlobalContext)

    const { contato, upd_doc } = useQuery()
    const history = useHistory()

    const [pessoa, setPessoa] = useState(null)
    const [showModalDocumentos, setShowModalDocumentos] = useState(false)

    async function loadPessoa() {
        try {
            const associado = await api.get(`associado/${user.associado.id}`, authHeaders())

            const matricula = associado.pessoa.documentos.find(documento => documento.tipo_documento.id === 2)?.identificador

            if (!matricula) {
                toast.error('CPF não consta na base de dados.')
                return
            }

            const response = await api.get(`pessoa/${associado.pessoa.id}`, authHeaders())

            const [sindicalizacaoMaisRecente] = response.associado.sindicalizacao.length ? response.associado.sindicalizacao
                .sort(arrayUtils.sort.comparisonFunction('data', 'desc')) : [null]

            response.sindicalizacao = sindicalizacaoMaisRecente?.data ? {
                data: format(new Date(sindicalizacaoMaisRecente.data), 'dd/MM/yyyy'),
                status: sindicalizacaoMaisRecente.status,
                motivo: sindicalizacaoMaisRecente.motivo_desligamento?.descricao,
                observacao: sindicalizacaoMaisRecente.observacao
            } : ''

            const nomes = response.nome.split(' ')
            response.nome_reduzido = `${nomes[0]} ${nomes.slice(1, nomes.length - 1).map(sobrenome => `${sobrenome[0]}. `).join(' ')}${nomes[nomes.length - 1]}`

            response.socio = response.associado.status_associacao.id === 3
            response.status = response.associado.status_associacao.descricao

            response.documentos = response.associado.pessoa.documentos

            response.endereco = response.associado.pessoa.endereco

            response.contatos = [
                ...response.associado.pessoa.contato.map(contato => ({
                    ...contato,
                    icone: contato.tipo_contato.icone
                }))
            ]

            const rgExtraData = response.documentos?.find(documento => documento.tipo_documento.id === 1)?.extra
            const rg_data_emissao = rgExtraData?.data_emissao || ''
            const rg_orgao_emissor = rgExtraData?.orgao_emissor || ''

            response.dados_pessoais = {
                cpf: response.documentos?.find(documento => documento.tipo_documento.id === 2)?.identificador || '',
                data_nascimento: response.data_nascimento ? format(stringToDate(response.data_nascimento), 'dd/MM/yyyy') : '',
                rg: response.documentos?.find(documento => documento.tipo_documento.id === 1)?.identificador || '',
                rg_data_emissao: rg_data_emissao ? format(stringToDate(`${rg_data_emissao} 00:00:00`), 'dd/MM/yyyy') : '',
                rg_orgao_emissor
            }

            if (response.formacoes) {
                response.formacoes = response.formacoes.map(formacao => ({
                    id: formacao.id,
                    formacao: formacao.formacao,
                    formacao_descricao: concatFormacoes(formacao.formacao),
                    instituicao: formacao.instituicao,
                    instituicao_descricao: formacao.instituicao.id === 9999 ? `${formacao.faculdade_a_aprovar.descricao} (não validado)` : (formacao.instituicao?.sigla || formacao.instituicao.descricao),
                    instituicao_a_aprovar_descricao: formacao.instituicao.id === 9999 ? formacao.faculdade_a_aprovar.descricao : null,
                    instituicao_cidade_uf: formacao.instituicao.id === 9999 ? formacao.faculdade_a_aprovar.local : null,
                    grau: formacao.grau,
                    grau_descricao: formacao.grau.descricao,
                    certificado: formacao.certificado?.link,
                    certificado_id: formacao.certificado?.id
                }))
            }

            setPessoa(response)
        } catch (e) {
            console.log(e)

            checkException(e)
        }
    }

    useEffect(() => {
        scrollUtils.toTop()

        if (user) {
            loadPessoa()
        }
    }, [user])

    useEffect(() => {
        if (contato) {
            setTimeout(() => {
                scrollUtils.toElement('.box-local-trabalho')
            }, 500)
        }
    }, [])

    useEffect(() => {
        setShowModalDocumentos(upd_doc && pessoa)
    }, [pessoa])

    useEffect(() => {
        loadTips(setCodigo, 'form_espaco_talento')
    }, [])

    async function reload() {
        setPessoa(null)
        setShowModalDocumentos(false)

        await loadPessoa()
    }

    async function updateDocumentos(values) {
        try {
            await api.put(`documentos/${pessoa.id}`, {
                documentos: values.documentos
                    .map(doc => ({
                        arquivo: doc.arquivo,
                        identificador: doc.identificador,
                        extra: doc.validade ? {
                            validade: getDateString(getDate(doc.validade))
                        } : doc.dataEmissao && doc.orgaoEmissor ? {
                            data_emissao: getDateString(getDate(doc.dataEmissao)),
                            orgao_emissor: doc.orgaoEmissor
                        } : doc.orgaoEmissor ? { orgao_emissor: doc.orgaoEmissor }
                            : doc.dataEmissao ? {
                                data_emissao: getDateString(getDate(doc.dataEmissao))
                            } : null,
                        tipo_documento: doc.tipo_documento.value
                    }))
            }, authHeaders())

            toast.success('Documentos atualizados.')

            history.push('/associado/dados_cadastrais')
        } catch (e) {
            checkException(e)
        }
    }

    if (!pessoa) {
        return null
    }

    return (
        <Container>
            <main className="animated fadeIn faster">
                {!pessoa?.formacoes?.length && (
                    <div
                        className="bg-yellow-500 px-3 py-2 rounded-lg shadow-md grid grid-cols-[3rem_auto] items-center text-slate-800 mb-6"
                        style={{ gridArea: 'alert' }}
                    >
                        <FiAlertTriangle size={26} />
                        <div
                            className="h-fit leading-relaxed"
                            dangerouslySetInnerHTML={{
                                __html: `Você não possui nenhuma <b>FORMAÇÃO</b> cadastrada em seu perfil. É essencial que você cadastre todos os <u>diplomas ou certificados</u> que possua, indicando o respectivo grau e instituição de ensino.`
                            }}
                        />
                    </div>
                )}

                <BoxDadosBasicos pessoa={pessoa} reload={reload} />

                <BoxDadosPessoais pessoa={pessoa} reload={reload} />

                <BoxEndereco pessoa={pessoa} reload={reload} />

                <BoxFormacoes pessoa={pessoa} reload={reload} />

                <BoxExperienciasProfissionais pessoa={pessoa} reload={reload} />

                <BoxContatos pessoa={pessoa} reload={reload} />

                <BoxDocumentos>
                    <h1>Documentos</h1>

                    <FiPlusCircle
                        data-tip="Adicionar"
                        data-for="tooltip"
                        onClick={() => { setShowModalDocumentos(true) }}
                    />

                    <BoxArquivos
                        title={null}
                        arquivos={pessoa?.documentos.map(doc => ({
                            ...doc,
                            link: doc.arquivo?.link || '',
                            nome: doc.tipo_documento.descricao
                        }))}
                    />
                </BoxDocumentos>
            </main>

            <ReactTooltip
                id="tooltip"
                place="top"
                effect="solid"
                backgroundColor="#fff"
                arrowColor="#fff"
                textColor="#424242"
                className="tooltip-default"
            />

            <Modal
                isOpen={showModalDocumentos}
                handleClose={() => { setShowModalDocumentos(false) }}
                title="Gerenciamento de documentos"
            >
                <GerenciamentoDocumentos
                    handleSubmit={updateDocumentos}
                    documentos={pessoa?.documentos.map(doc => ({
                        id: doc.id,
                        arquivo: doc.arquivo,
                        tipo_documento: doc.tipo_documento,
                        extra: doc.extra,
                        identificador: doc.identificador
                    }))}
                    enablePreview={false}
                />
            </Modal>
        </Container>
    )
}
